import { asSceneKey, type SceneKey } from '../sceneKeys.js';

export const BOOT_SCENE_KEY: SceneKey = asSceneKey('Boot');
